import type { Theme } from '@mui/material/styles';
import type { SvgIconComponent } from '@mui/icons-material';
import {
  AttachFileOutlined,
  ChatBubbleOutline,
  CollectionsOutlined,
  DocumentScannerOutlined,
  HistoryOutlined,
  ImageOutlined,
  StickyNote2Outlined,
} from '@mui/icons-material';

export type DecoratedSectionIcon =
  | 'notes'
  | 'attachments'
  | 'resolution'
  | 'images'
  | 'scanImages'
  | 'fingerprintImages'
  | 'auditHistory';

/** @deprecated Use DecoratedSectionIcon */
export type NotesSectionIcon = DecoratedSectionIcon;

type AccentKey = 'info' | 'secondary' | 'primary';

const ICON_BY_VARIANT: Record<DecoratedSectionIcon, SvgIconComponent> = {
  notes: ChatBubbleOutline,
  attachments: AttachFileOutlined,
  resolution: StickyNote2Outlined,
  images: ImageOutlined,
  scanImages: DocumentScannerOutlined,
  fingerprintImages: CollectionsOutlined,
  auditHistory: HistoryOutlined,
};

const ACCENT_BY_ICON: Record<DecoratedSectionIcon, AccentKey> = {
  notes: 'info',
  attachments: 'info',
  resolution: 'info',
  images: 'secondary',
  scanImages: 'primary',
  fingerprintImages: 'secondary',
  auditHistory: 'secondary',
};

export function getDecoratedSectionIcon(icon: DecoratedSectionIcon): SvgIconComponent {
  return ICON_BY_VARIANT[icon];
}

export function getDecoratedSectionAccent(theme: Theme, icon: DecoratedSectionIcon) {
  return theme.palette[ACCENT_BY_ICON[icon]].main;
}
